import React from "react"
import useIsMobile from "@Hooks/selector/useIsMobile"
import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type"
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type"
import SuggestedRouteType from "@Route/types/SuggestedRoute.type"
import RouteClosedOrUnavailable
    from "@Route/features/status/features/closedOrUnavailable/components/RouteClosedOrUnavailable"
import Discount from "@Route/components/Price/Discount/Discount"
import RouteActionButton from "@Route/features/ticketPurchase/components/RouteActionButton"
import RouteTotalPriceContainer from "@Route/components/Price/RouteTotalPriceContainer"
import ParamsType from "@SearchResults/types/params/Params.type"
import routeIsClosedOrUnavailable from "@Route/features/status/functions/routeIsClosedOrUnavailable";
import RouteStatusBadges from "@Route/features/statusBadges/components/RouteStatusBadges";

interface RouteStatusContainerProps {
    route: IntermodalRouteWithDetailsType | RouteWithAddedPropsAndPricesType | SuggestedRouteType,
    isReturn: boolean,
    params: ParamsType,
}

function RouteStatusContainer(props: RouteStatusContainerProps) {
    const {
        route,
        isReturn,
        params,
    } = props

    const {
        prices,
        status: {
            status,
            soldOut,
            isSuggestion,
        },
    } = route

    const {discounts, price} = prices

    const isMobile = useIsMobile()

    const hasDiscounts = !isSuggestion && !!Object.keys(discounts)?.length && status === "open"

    const isClosedOrUnavailable = routeIsClosedOrUnavailable(status)

    return (
        <div className={`gb--row gb--route-status ${isClosedOrUnavailable ? "gb--route-status__closed" : ""}`}>
            {isClosedOrUnavailable ? (
                <RouteClosedOrUnavailable
                    soldOut={soldOut}
                    closed={status === "closed"}
                    unavailable={status === "unavailable"}
                />
            ) : (
                <RouteTotalPriceContainer
                    route={route}
                    totalPrice={price}
                />
            )}
            <RouteStatusBadges
                route={route}
            />
            {hasDiscounts && !isMobile && (
                <Discount
                    prices={prices}
                />
            )}
            {status === "open" && !isMobile && (
                <RouteActionButton
                    params={params}
                    route={route}
                    expandedPanel={false}
                    isReturn={isReturn}
                />
            )}
        </div>
    )
}

export default RouteStatusContainer